<template>
  <div>
    <div class="tile is-parent">
        <article class="tile box" style="">
          <form v-on:submit="updateTimeOnice">
          <div>
              <table class="table">
            <thead>
              <tr>
                <th>#</th>
                <th>Player</th>
                <th>GP</th>
                <th>+ Shots</th>
                <th>- Shots</th>
                <th>Shifts</th>
                <th>Time Avg Shift</th>
                <th>Time Total</th>
                <th>Time 5v5</th>
                <th>Time 4v4</th>
                <th>Time PP</th>
                <th>Time SH</th>
              </tr>
            </thead>
            <tbody>
               <tr>
                    <tr v-for="toi in TOI">
                      <td>{{toi.player_number}}</td>
                      <td>{{toi.player_forename}} {{toi.player_surname}}</td>
                      <td><label ><input class="checkbox" type="checkbox"  checked="checked" value="" v-model="toi.played_in_game"></label></td> 
                      <td><input class="input " type="number" placeholder="0" v-model="toi.shots_for"></td>
                      <td><input class="input " type="number" placeholder="0" v-model="toi.shots_against"></td>
                      <td><input class="input " type="number" placeholder="0" v-model="toi.shifts"></td>
                      <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.avg_shift"></datepicker></td>
                      <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.total_time"></datepicker></td>
                      <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_5v5"></datepicker></td>
                      <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_4v4"></datepicker></td>
                      <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_PP"></datepicker></td>
                      <td><datepicker  placeholder="--:--" :config="{ enableTime: true, enableSeconds: true, noCalendar: true, time_24hr:true }" value="00:00:00" v-model="toi.time_SH"></datepicker></td>
                    </tr>
            </tr>
            </tbody>
          </table>
            <p class="control" style="margin-top:20px">
              <button name="submit" class="button is-primary is-medium">Submit</button>
              <router-link class="button is-link is-small" v-bind:to="'/editors/Player/'">Cancel</router-link>
            </p>
          </div>
          </form>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import Cleave from 'vue-cleave'
import 'cleave.js/dist/addons/cleave-phone.cn'
import Datepicker from 'vue-bulma-datepicker'

export default {
  components: {
    Cleave,
    Datepicker
  },

  data () {
    return {
      Player: [],
      TOI: []
    }
  },

  methods: {
    fetchGoal (id) {
      console.log('Get query')
      this.$http.get('https://devilsapi.roblutken.com/api/players/home/get', { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
      response => {
        this.Player = response.data
        console.log(response.data)
        console.log('In Created: ' + this.Player[0] + ' ' + this.Player.length)
        for (let i = 0; i < this.Player.length; i++) {
          console.log(this.Player[i].forename)
          this.TOI.push({
            player_id: this.Player[i].id,
            player_forename: this.Player[i].forename,
            player_surname: this.Player[i].surname,
            player_number: this.Player[i].player_number,
            played_in_game: 0,
            shots_for: 0,
            shots_against: 0,
            shifts: 0,
            avg_shift: '',
            total_time: '',
            time_5v5: '',
            time_4v4: '',
            time_PP: '',
            time_SH: ''
          })
        }
      }, response => {
      })
    },
    updateTimeOnice (e) {
      e.preventDefault()
      console.log(this.TOI)
      /* let updateGoal = {
        player_id: this.Player[0].scorer.player_number,
        first_assist: this.Player[0].first_assist.player_number,
        second_assist: this.Player[0].second_assist.player_number,
        period: this.Player[0].period,
        situation: this.Player[0].situation.secondary_situation
      } */

      console.log(this.$route.params.id)
      for (let i = 0; i < this.Player.length; i++) {
        this.$http.put('https://devilsapi.roblutken.com/api/timeonice/update/' + this.$route.params.id,
        this.TOI[i], { headers: { Authorization: 'Basic ZGV2aWxzYWRtaW46SDM1dlRwTnc=' } }).then(
        response => {
          console.log(response.data)
        }, response => {
        })
      }
    },
    onRawValueChanged (newVal) {
      this.demo.rawValue = newVal
    }
  },
  watch: {
    'demo.value' (newVal, oldVal) {
      console.log('value: new ->', newVal, 'old ->', oldVal)
    },
    'demo.rawValue' (newVal, oldVal) {
      console.log('rawValue: new ->', newVal, 'old ->', oldVal)
    }
  },
  created: function () {
    this.fetchGoal(this.$route.params.id)
  }
}
</script>

<style lang="scss" scoped>
@import '~bulma/sass/utilities/mixins';

.button {
  margin: 5px 0 0;
}

.control .button {
  margin: inherit;
}

.control.has-addons {
  @include mobile() {
    input {
      width: 100%;
    }

    input.is-expanded {
      flex-shrink: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// time-on-ice-edit.vue?7a803104